// React
import React from 'react';
// External
import {
    Image, Row, Col
} from 'react-bootstrap';
// Internal
import NavbarPrimary from 'components/shared/organisms/NavbarPrimary/NavbarPrimary';
import NavbarSecondary from 'components/shared/organisms/NavbarSecondary/NavbarSecondary';
import PageTitle from 'components/shared/atoms/PageTitle/PageTitle';
import ContentCard from 'components/shared/organisms/ContentCard/ContentCard';
import HeaderDivider from 'components/shared/atoms/HeaderDivider/HeaderDivider';
import GUIDANCE_MATERIAL from 'constants/guidanceMaterialLinks';
import { isLawnswoodBrand } from 'services/users';
import BrandService from 'services/brand';
import VetService from 'services/vet';
// Style
import './styles.scss';
import CustomTable from 'components/shared/molecules/CustomTable/CustomTable';

class CustomerSupport extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            teamRepresentative: null,
            clientCare: null,
            brandName: '',
            brandData: {},
        };

        this.phoneFormats = {
            clientCare: [2, 4, 4],
            teamRepresentative: [4, 3, 3],
        };

        this.getVetDetails();
        this.getTeamRepresentative();

        this.guidanceMaterial = [];
    }

    getContactClientCare() {
        BrandService.getBrand(this.state.brandName)
            .then((response) => {
                if (response.data) {
                    this.setState({
                        clientCare: {
                            name: this.getParentBrandName(response.data.parent) + ' Client Care',
                            email: this.getEmail(response.data),
                            officePhone: response.data.phone_work,
                        }
                    });
                }
            }).catch((err) => {
                console.error(err);
            });
    }

    getTeamRepresentative() {
        VetService.getTeamRepresentative()
            .then((response) => {
                if (response.data && response.data.email_addresses.length) {
                    this.setState({
                        teamRepresentative: response.data
                    });
                }
            }).catch((err) => {
                console.error(err);
            });
    }

    getFullName() {
        return `${this.state.teamRepresentative.first_name} ${this.state.teamRepresentative.last_name}`;
    }

    /**
     * Get phone number hyperlink
     * 
     * @param {String} strPhone
     * @param {Array} strPhone  
     * 
     * @returns
     */
    getPhoneHyperlink(strPhone, arFormat) {
        // Stop if the team representative/assigned user has no mobile phone
        if (!strPhone) {
            return;
        }

        const phoneMobileArr = [];

        if (strPhone.startsWith('+')) {
            strPhone = strPhone.replace('+61', '0');
        }

        phoneMobileArr.push(strPhone.substring(0, arFormat[0]));
        phoneMobileArr.push(strPhone.substring(arFormat[0], arFormat[0] + arFormat[1]));
        phoneMobileArr.push(strPhone.substring(arFormat[0] + arFormat[1]));

        strPhone = phoneMobileArr.join('-');

        return <a href={`tel:${phoneMobileArr.join('-')}`}>{phoneMobileArr.join(' ')}</a>;
    }

    /**
     * Extract parent brand name
     * 
     * @param {String} strParentBrand 
     * 
     * @returns {String}
     */
    getParentBrandName = (strParentBrand) => {
        if (strParentBrand.includes('Lawnswood')) {
            return 'Lawnswood';
        }

        if (strParentBrand.includes('Edenhills')) {
            return 'Edenhills';
        }
        
        if (strParentBrand.includes('Patch and Purr')) {
            return 'Patch and Purr';
        }

        if (strParentBrand.includes('Pets in Peace')) {
            return 'Pets in Peace';
        }

        return '';
    }

    getEmail = (data) => {
        if (data && data.email_addresses && data.email_addresses.length) {
            return <a href={`mailto:${data.email_addresses[0].email_address}`}>{data.email_addresses[0].email_address}</a>;
        }
        return null;
    }

    /**
     * Retrieves the brand data based on the brand name.
     * @param {string} brandName - The brand name.
     * @returns {Object} - An object containing the bucketListUrl and griefGuidanceUrl.
     */
    getBrandData(brandName) {
        if (brandName.includes('LWD')) {
            return {
                bucketListUrl: GUIDANCE_MATERIAL.lawnswood.bucketList,
                griefGuidanceUrl: GUIDANCE_MATERIAL.lawnswood.griefGuidance,
            };
        }

        if (brandName.includes('EDH')) {
            let edenhillsGriefGuidance = '';

            if (this.state.brandName.includes("AW")) {
                edenhillsGriefGuidance = GUIDANCE_MATERIAL.edenhills.griefGuidance.AW;
            }
    
            if (this.state.brandName.includes("VIC")) {
                edenhillsGriefGuidance = GUIDANCE_MATERIAL.edenhills.griefGuidance.VIC;
            }
    
            if (this.state.brandName.includes("SA")) {
                edenhillsGriefGuidance = GUIDANCE_MATERIAL.edenhills.griefGuidance.SA;
            }

            return {
                bucketListUrl: GUIDANCE_MATERIAL.edenhills.bucketList,
                griefGuidanceUrl: edenhillsGriefGuidance,
            };
        }

        if (brandName.includes('NSW')) {
            let nswGriefGuidance = '';
            let nswBucketList = '';

            if (this.state.brandName.includes("SW")) {
                nswGriefGuidance = GUIDANCE_MATERIAL.nsw.griefGuidance.SW;
                nswBucketList = GUIDANCE_MATERIAL.nsw.bucketList.SW;
            }
    
            if (this.state.brandName.includes("CW")) {
                nswGriefGuidance = GUIDANCE_MATERIAL.nsw.griefGuidance.CW;
                nswBucketList = GUIDANCE_MATERIAL.nsw.bucketList.CW;
            }
    
            if (this.state.brandName.includes("MO")) {
                nswGriefGuidance = GUIDANCE_MATERIAL.nsw.griefGuidance.MO;
                nswBucketList = GUIDANCE_MATERIAL.nsw.bucketList.MO;
            }

            return {
                bucketListUrl: nswBucketList,
                griefGuidanceUrl: nswGriefGuidance,
            };
        }

        if (brandName.includes('QLD')) {
            return {
                bucketListUrl: GUIDANCE_MATERIAL.qld.bucketList,
                griefGuidanceUrl: GUIDANCE_MATERIAL.qld.griefGuidance,
            };
        }
    }

    /**
     * Get the guidance material data
     */
    getGuidanceMaterials(brandName) {
        const { bucketListUrl, griefGuidanceUrl } = this.getBrandData(brandName);
        
        this.guidanceMaterial = [
            [
                'Pet Bucket List',
                'PDF',
                'Creating a Bucket List is a great way to honour your friendship before your pet passes',
                <a
                    href={bucketListUrl}
                    target="_blank"
                    className="guidance-link"
                    rel="noopener noreferrer"
                >
                    View
                </a>
            ],
            [
                'Pet Loss and Grief Brochure',
                'PDF',
                'Support for you and your family',
                <a
                    href={griefGuidanceUrl}
                    target="_blank"
                    className="guidance-link"
                    rel="noopener noreferrer"
                >
                    View
                </a>
            ]
        ];
    }

    /**
     * Get Vet Detail
     */
     getVetDetails() {
        VetService.getVetDetails()
            .then((response) => {
                this.setState({ brandName: response.data.cstm.brand.name }, () => {
                    this.getGuidanceMaterials(response.data.cstm.brand.name);
                    this.getContactClientCare();
                });
            }).catch((err) => {
                console.error(err);
            });
    }

    render() {
        return (
            <div className="main-container">
                <NavbarSecondary />
                <NavbarPrimary />
                <div className="body-content">
                    <PageTitle title="Customer support" />
                    <ContentCard
                        className="mt-62 tagging-content-card pb-4"
                        divider={false}
                        headerBtnText="View more"
                    >
                        <div className="help-container">
                            <HeaderDivider title="Client Care Team" className="help-header pt-4" />
                            <p className="">
                                You can contact our client care team for support with bookings and client queries.
                            </p>
                            <Row>
                                {
                                    this.state.clientCare
                                        ? (
                                            <Col className="col pl-4" md="12" lg="12">
                                                <p>{this.state.clientCare.name}</p>
                                                <p>{this.getPhoneHyperlink(this.state.clientCare.officePhone, this.phoneFormats.clientCare)}</p>
                                                <p>{this.state.clientCare.email}</p>
                                            </Col>
                                        ) : null
                                }
                            </Row>
                            <HeaderDivider title="Relationship Manager" className="help-header pt-4" />
                            <p className="">
                                You can contact your local relationship manager with support queries and feedback, or to request an on-site visit.
                            </p>
                            <Row>
                                {
                                    this.state.teamRepresentative?.picture?.src
                                        ? (
                                            <Col>
                                                <Image
                                                    src={this.state.teamRepresentative.picture.src}
                                                    width="80"
                                                    height="80"
                                                />
                                            </Col>
                                        )
                                        : null
                                }
                                {
                                    this.state.teamRepresentative
                                        ? (
                                            <Col className="pl-4">
                                                <p>{this.getFullName()}</p>
                                                <p>{this.getPhoneHyperlink(this.state.teamRepresentative.phone_mobile, this.phoneFormats.teamRepresentative)}</p>
                                                <p>{this.getEmail(this.state.teamRepresentative)}</p>
                                            </Col>
                                        ) : null
                                }
                            </Row>
                        </div>
                    </ContentCard>
                    <ContentCard
                        className="mt-40 tagging-content-card"
                        divider={false}
                        headerTitle="Grief guidance material"
                        headerBtnText="View more"
                        headerSubComponent={(
                            <p className="guidance-sub-header">
                                Download any of the following documents to provide to clients as necessary.
                            </p>
                        )}
                    >
                        <CustomTable
                            className="guidance-table"
                            data={this.guidanceMaterial}
                            headers={['DOCUMENT NAME', 'FILE TYPE', 'DESCRIPTION', '']}
                        />
                    </ContentCard>
                </div>
            </div>
        );
    }
}

export default CustomerSupport;
